import { Vue, Component, Prop } from 'vue-property-decorator';
import SummaryPullupHeader from '@/components/pull-up/summary-pullup-header/summary-pullup-header';
import moment from 'moment';
import { reportsApi } from '@/providers/apis/reports/reports';
import { sessionService } from '@/providers/services/auth/session';
import StudentMasteryReport from '@/components/pull-up/student-mastery-pullup/student-mastery-pullup';

@Component({
    name: 'performance-summary-drill-down',
    components: {
        'summary-pullup-header': SummaryPullupHeader,
        'student-mastery-pullup': StudentMasteryReport,
    },
})

export default class PerformanceSummaryReport extends Vue {
    public get session() {
        return sessionService.getSession();
    }
    public reportData: any = null;

    public isLoading: any = false;

    public subjectList: any = [];

    public selectedSubject: any = null;

    public paramsPayload: any = {
        from_year: moment().year() - 1,
        to_year: moment().format('YYYY'),
        from_month: moment().format('MM'),
        to_month: moment().format('MM'),
    };

    public isStudentMastery: boolean = false;

    public userPerformance: any = null;

    public selectedmasteryData: any = null;

    public headerField: any =  [
        {
            label: 'Grade',
            key: 'gradeName',
        },
        {
            label: 'Total competencies',
            key: 'totalCompetency',
        },
        {
            label: 'Number of competencies which have been mastered by more than 75% students',
            key: 'highPercent',
        },
        {
            label:  'Number of competencies which have been mastered by 40- 75% students',
            key: 'midPercent',
        },
        {
            label: 'Number of competencies which have been mastered by less than 40% students',
            key: 'lowPercent',
        },
    ];

    public selectedCompetency: any = [];

    public selectedTitle: any = null;

    public type: any = null;

    public activeTenantId: any;

    private items: any = [];

    public async created() {
        const activeTenant = this.$access.getGroupHierarchyTenants;
        this.activeTenantId = JSON.parse(activeTenant).id;
        const params = {
            tenants: this.activeTenantId ? this.activeTenantId : this.session!.tenant!.tenant_id,
        };
        await reportsApi.fetchSubjectList(params).then((response) => {
            this.subjectList = response;
            this.selectedSubject = this.subjectList[0];
        });
    }

    public onSelectSubject(subject: any) {
        this.selectedSubject = subject;
        if (!subject) {
            delete this.paramsPayload.subject;
        }
        this.loadData();
    }

    public handleRangeSelection(rangeData: any) {
        this.paramsPayload = {
            ...this.paramsPayload,
            ...rangeData,
        };
        this.loadData();
    }

    public onChangeFilter(type: string, drilldownData: any) {
        this.paramsPayload = {
            ...this.paramsPayload,
            group_type: type,
        };
        if (type === 'class') {
            this.paramsPayload.class_ids = drilldownData ? drilldownData.join(',') : '';
        } else {
            this.paramsPayload.group_ids = drilldownData ? drilldownData.join(',') : '';
        }
        if (!drilldownData || !drilldownData.length) {
            delete this.paramsPayload.group_type;
            delete this.paramsPayload.group_ids;
        }
        this.loadData();
    }

    public onSelectRow(grade: any, type: string) {
        const selectedData = this.userPerformance.find((user: any) => user.gradeName === grade);
        this.type = type;
        if (type === 'high') {
            this.selectedCompetency = selectedData.highPercentCompetency;
            this.selectedTitle = 'Competencies which have been mastered by more than 75% students';
        }
        if (type === 'medium') {
            this.selectedCompetency = selectedData.midPercentCompetency;
            this.selectedTitle = 'Competencies which have been mastered by 40- 75% students';
        }
        if (type === 'low') {
            this.selectedCompetency = selectedData.lowPercentCompentency;
            this.selectedTitle = 'Competencies which have been mastered by less than 40% students';
        }
        this.isStudentMastery = true;
    }

    public onClosePerformancePullup() {
        this.isStudentMastery = false;
    }

    private loadData() {
        this.isLoading = true;
        this.items = [];
        this.paramsPayload.tenants = this.activeTenantId ? this.activeTenantId : this.session!.tenant!.tenant_id;
        this.paramsPayload.subject = this.selectedSubject.code;
        reportsApi.fetchUserCompetencyPerformance(this.paramsPayload).then((response) => {
            this.userPerformance = response;
            this.isLoading = false;
        });
    }
}
